import React, { useState, useEffect } from "react";
import AdminNavbar from "./AdminNavbar";
import iptlogo from "assets/img/IPT Logo.png";
import indiamap from "assets/img/indiamap.png";
import uaemap from "assets/img/uaemap.png";

const IndexNavbarr = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("ourPartners");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // uae products
  

  const clientPartners = [
    {
      icon: "fa-cogs",
      title: "Evoguard GmbH",
      desc: "Valves and pumps for hygienic processing.",
      link: "/evoguard",
      descLink: "/evoguard",
    },

    {
      icon: "fa-industry",
      title: "Ampco pumps",
      desc: "Durable sanitary pump manufacturer",
      link: "/Ampcopumps",
      descLink: "/Ampcopumps",
    },

    {
      icon: "fa-user-tie",
      title: "Perfinox S.A",
      desc: "Custom stainless process solutions.",
      link: "/Perfinoxsa",
      descLink: "/Perfinoxsa",
    },
    {
      icon: "fa-building",
      title: "HST Maschinenbau ",
      desc: "High-pressure homogenizer systems.",
      link: "/HSTMaschinenbau",
      descLink: "/HSTMaschinenbau",
    },

  ];

  // india and uae
  const [scrolling, setScrolling] = useState(false);
  const [selectedNavbar, setSelectedNavbar] = useState("UAE"); // Default to 'IN'
  const [dropdownOpen, setDropdownOpen] = useState(null);

  // header scrolling

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDropdown = (menu) => {
    setDropdownOpen(dropdownOpen === menu ? null : menu);
  };

  return (
    <section>
      <section className="poppins xl:block lg:block md:hidden sm:hidden hidden">
        <div className={`bg-white ${scrolling ? "fixed-header" : ""}`}>
          <div className="flex justify-between items-center flex-wrap gap-0 container mx-auto xl:px-0 px-4">
            <div className="xl:w-3/12 lg:w-2/12">
              <div className="flex items-center gap-4">
                <a href="/homepagenext">
                  <img
                    className="xl:w-7/12 lg:w-12/12 xl:-ml-8 lg:-ml-8"
                    src={iptlogo}
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div className="xl:-ml-16 lg:-ml-4">
              {selectedNavbar === "UAE" ? (
                 <div className="flex xl:gap-8 lg:gap-8">
                 <a
                   href="/about-us"
                   className="flex items-center xl:text-base text-sm text-black xl:mt-1 lg:mt-1"
                 >
                   About
                 </a>

                 <div
      className="dropdown-container xl:mt-3 lg:mt-4 flex items-center"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <a
        href="/Ampcopumps"
        className="flex items-center xl:text-base text-sm text-black"
      >
        Products <i className="fas fa-chevron-down ml-2"></i>
      </a>
      {isOpen && (
        <div className="dropdown-content xl:mt-2">
          <div
            className="grid xl:grid-cols-4 lg:grid-cols-4 rounded-md bg-white"
            style={{
              minWidth: "1000px",
              maxWidth: "1000px",
              zIndex: "100",
            }}
          >
            <div
              className="col-span-1 xl:py-8 xl:pl-6 lg:pl-16 lg:py-8"
              style={{ backgroundColor: "#f7fafc" }}
            >
              <h3
                className={`cursor-pointer font-semibold xl:text-2xl text-xl flex items-center gap-2 ${activeTab === "clientPartners" ? "text-blue" : ""
                  }`}
                onClick={() => setActiveTab("clientPartners")}
              >
                <i className="fas fa-users text-lg"></i> Client Partners
              </h3>
            </div>
            <div className="col-span-3 p-4 grid grid-cols-3 gap-4 rounded-md xl:py-8">
              {clientPartners.map((partner, index) => (
                <div
                  key={index}
                  className="flex items-center p-4 rounded-md transition min-h-[80px]"
                  style={{
                    backgroundColor:
                      hoveredIndex === index ? "#f7fafc" : "#fff",
                    transition: "background-color 0.3s ease-in-out",
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <i
                    className={`fas ${partner.icon} text-lg flex-shrink-0`}
                    style={{
                      border: "1px solid #2d86a4",
                      borderRadius: "10%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px",
                    }}
                  ></i>
                  <div className="flex-1">
                    <a
                      href={partner.link}
                      className="font-semibold text-black"
                    >
                      {partner.title}
                    </a>
                    <a
                      href={partner.descLink}
                      className="text-xs text-gray-600 block"
                    >
                      {partner.desc}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      </div>
    {/*   <div
                   className="dropdown-container xl:mt-3 lg:mt-4 relative"
                   onMouseEnter={() => setIsOpen(true)}
                   onMouseLeave={() => setIsOpen(false)}
                 >
                   <a
                     href="/service"
                     className="flex items-center xl:text-base text-sm text-black"
                   >
                     Services
                     <i className="fas fa-chevron-down ml-2"></i>
                   </a>
                   {isOpen && (
                     <div
                       className="dropdown-content absolute xl:mt-2 bg-white py-6 px-6 rounded-md shadow-lg"
                       style={{
                         width: "890px",
                         maxWidth: "890px",
                         zIndex: 100,
                       }}
                     >
                       <ul className="grid grid-cols-3 p-2">
                         {[
                           {
                             icon: "fa-industry",
                             title: "Dairy Plant",
                             desc: "Efficient dairy processing and production solutions.",
                           },
                           {
                             icon: "fa-wine-glass",
                             title: "Juice",
                             desc: "State-of-the-art juice processing technologies.",
                           },
                           {
                             icon: "fa-glass-whiskey",
                             title: "Beverages",
                             desc: "Comprehensive beverage manufacturing solutions.",
                           },
                           {
                             icon: "fa-cheese",
                             title: "Cheese Plants",
                             desc: "Advanced cheese production and processing facilities.",
                           },
                           {
                             icon: "fa-tint",
                             title: "Water Plants",
                             desc: "High-quality water purification and bottling systems.",
                           },
                           {
                             icon: "fa-pump-soap",
                             title: "Personal Care",
                             desc: "Innovative solutions for personal care product manufacturing.",
                           },
                           {
                             icon: "fa-flask",
                             title: "Cosmetics",
                             desc: "Cutting-edge technology for cosmetic production.",
                           },
                           {
                             icon: "fa-utensils",
                             title: "Culinary",
                             desc: "Culinary processing and food preparation systems.",
                           },
                           {
                             icon: "fa-candy-cane",
                             title: "Chocolate & Sweets",
                             desc: "Specialized solutions for chocolate and confectionery.",
                           },
                           {
                             icon: "fa-oil-can",
                             title: "Edible Oil",
                             desc: "Refined edible oil extraction and processing solutions.",
                           },
                           {
                             icon: "fa-cookie-bite",
                             title: "Confectioneries",
                             desc: "Complete confectionery production lines.",
                           },
                           {
                             icon: "fa-prescription-bottle",
                             title: "Pharmaceuticals",
                             desc: "Pharmaceutical manufacturing and packaging systems.",
                           },
                           {
                             icon: "fa-pepper-hot",
                             title: "Spices",
                             desc: "Automated spice grinding and packaging systems.",
                           },
                           {
                             icon: "fa-atom",
                             title: "Chemical",
                             desc: "Chemical processing and manufacturing solutions.",
                           },
                         ].map((service, index) => (
                           <li
                             key={index}
                             className="flex items-center"
                             style={{ height: "75px" }}
                           >
                             <i
                               className={`fas ${service.icon} text-lg p-2 mr-4`}
                               style={{
                                 border: "1px solid #2d86a4",
                                 borderRadius: "10%",
                                 width: "40px",
                                 height: "40px",
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                               }}
                             ></i>
                             <div className="flex-1">
                               <a
                                 href="/service"
                                 className="font-semibold text-black"
                               >
                                 {service.title}
                               </a>
                               <a href="/service">
                                 <p className="text-xs text-para">
                                   {service.desc}
                                 </p>
                               </a>
                             </div>
                           </li>
                         ))}
                       </ul>
                     </div>
                   )}
                 </div> */}

                 <a
                   href="/contact-uae"
                   className="flex items-center xl:text-base pt-1 text-sm text-black"
                 >
                   Contact
                 </a>

                 <div className="flex gap-4">
                   <img
                     src={indiamap}
                     alt="India"
                     className={`cursor-pointer w-11 h-11 mt-1  ${selectedNavbar === "IN"
                       ? "border-b-4 border-blue-600"
                       : ""
                       }`}
                     onClick={() => setSelectedNavbar("IN")}
                   />
                   <img
                     src={uaemap}
                     alt="UAE"
                     className={`cursor-pointer w-12 h-12  text-black ${selectedNavbar === "UAE" ? "" : ""
                       }`}
                     onClick={() => setSelectedNavbar("UAE")}
                   />
                 </div>
                 <a href="/contact-uae">
                   <button className="blue text-white xl:px-8 xl:py-2 lg:px-4 lg:py-2 rounded-md xl:mt-0 lg:mt-1">
                     Get A Quote UAE
                   </button>
                 </a>
               </div>
                
              ) : (
                <div className="flex xl:gap-8 lg:gap-8 ">
                <a
                  href="/about-us"
                  className="flex items-center xl:text-base text-sm xl:mt-1 lg:mt-1 text-black "
                >
                  About
                </a>

                <div
                  className="dropdown-container xl:mt-3 lg:mt-4 flex items-center relative"
                  onMouseEnter={() => setIsOpen(true)}
                  onMouseLeave={() => setIsOpen(false)}
                >
                  <a
                    href="/product"
                    className="flex items-center xl:text-base text-sm text-black"
                  >
                    Products
                    <i className="fas fa-chevron-down ml-2"></i>
                  </a>
                  {isOpen && (
                    <div className="dropdown-content xl:p-4 xl:mt-2 absolute bg-white shadow-lg">
                      <ul
                        className="grid grid-cols-3 p-4 rounded-md bg-white"
                        style={{
                          minWidth: "900px",
                          width: "auto",
                          maxWidth: "900px",
                          zIndex: "100",
                        }}
                      >
                        {[
                          {
                            icon: "fa-industry",
                            title: "Dairy Plant",
                            desc: "Efficient dairy processing and production solutions.",
                          },
                          {
                            icon: "fa-wine-glass",
                            title: "Juice",
                            desc: "State-of-the-art juice processing technologies.",
                          },
                          {
                            icon: "fa-glass-whiskey",
                            title: "Beverages",
                            desc: "Comprehensive beverage manufacturing solutions.",
                          },
                          {
                            icon: "fa-cheese",
                            title: "Cheese Plants",
                            desc: "Advanced cheese production and processing facilities.",
                          },
                          {
                            icon: "fa-tint",
                            title: "Water Plants",
                            desc: "High-quality water purification and bottling systems.",
                          },
                          {
                            icon: "fa-pump-soap",
                            title: "Personal Care",
                            desc: "Innovative solutions for personal care product manufacturing.",
                          },
                          {
                            icon: "fa-flask",
                            title: "Cosmetics",
                            desc: "Cutting-edge technology for cosmetic production.",
                          },
                          {
                            icon: "fa-utensils",
                            title: "Culinary",
                            desc: "Culinary processing and food preparation systems.",
                          },
                          {
                            icon: "fa-candy-cane",
                            title: "Chocolate & Sweets",
                            desc: "Specialized solutions for chocolate and confectionery.",
                          },
                          {
                            icon: "fa-oil-can",
                            title: "Edible Oil",
                            desc: "Refined edible oil extraction and processing solutions.",
                          },
                          {
                            icon: "fa-cookie-bite",
                            title: "Confectioneries",
                            desc: "Complete confectionery production lines.",
                          },
                          {
                            icon: "fa-prescription-bottle",
                            title: "Pharmaceuticals",
                            desc: "Pharmaceutical manufacturing and packaging systems.",
                          },
                          {
                            icon: "fa-pepper-hot",
                            title: "Spices",
                            desc: "Automated spice grinding and packaging systems.",
                          },
                          {
                            icon: "fa-atom",
                            title: "Chemical",
                            desc: "Chemical processing and manufacturing solutions.",
                          },
                        ].map((product, index) => (
                          <li
                            key={index}
                            className="flex items-center  border-b border-gray-300"
                          >
                            <i
                              className={`fas ${product.icon} text-lg flex-shrink-0`}
                              style={{
                                border: "1px solid #2d86a4",
                                borderRadius: "10%",
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "16px",
                              }}
                            ></i>
                            <div className="flex-1">
                              <a
                                href="/product"
                                className="font-semibold text-black"
                              >
                                {product.title}
                              </a>
                              <a href="/product">
                                <p className="text-xs text-gray-600">
                                  {product.desc}
                                </p>
                              </a>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                {/* <div
                  className="dropdown-container xl:mt-3 lg:mt-4 relative"
                  onMouseEnter={() => setIsOpen(true)}
                  onMouseLeave={() => setIsOpen(false)}
                >
                  <a
                    href="/service"
                    className="flex items-center xl:text-base text-sm text-black"
                  >
                    Services
                    <i className="fas fa-chevron-down ml-2"></i>
                  </a>
                  {isOpen && (
                    <div
                      className="dropdown-content absolute xl:mt-2 bg-white py-6 px-6 rounded-md shadow-lg"
                      style={{
                        width: "890px",
                        maxWidth: "890px",
                        zIndex: 100,
                      }}
                    >
                      <ul className="grid grid-cols-3 p-2">
                        {[
                          {
                            icon: "fa-industry",
                            title: "Dairy Plant",
                            desc: "Efficient dairy processing and production solutions.",
                          },
                          {
                            icon: "fa-wine-glass",
                            title: "Juice",
                            desc: "State-of-the-art juice processing technologies.",
                          },
                          {
                            icon: "fa-glass-whiskey",
                            title: "Beverages",
                            desc: "Comprehensive beverage manufacturing solutions.",
                          },
                          {
                            icon: "fa-cheese",
                            title: "Cheese Plants",
                            desc: "Advanced cheese production and processing facilities.",
                          },
                          {
                            icon: "fa-tint",
                            title: "Water Plants",
                            desc: "High-quality water purification and bottling systems.",
                          },
                          {
                            icon: "fa-pump-soap",
                            title: "Personal Care",
                            desc: "Innovative solutions for personal care product manufacturing.",
                          },
                          {
                            icon: "fa-flask",
                            title: "Cosmetics",
                            desc: "Cutting-edge technology for cosmetic production.",
                          },
                          {
                            icon: "fa-utensils",
                            title: "Culinary",
                            desc: "Culinary processing and food preparation systems.",
                          },
                          {
                            icon: "fa-candy-cane",
                            title: "Chocolate & Sweets",
                            desc: "Specialized solutions for chocolate and confectionery.",
                          },
                          {
                            icon: "fa-oil-can",
                            title: "Edible Oil",
                            desc: "Refined edible oil extraction and processing solutions.",
                          },
                          {
                            icon: "fa-cookie-bite",
                            title: "Confectioneries",
                            desc: "Complete confectionery production lines.",
                          },
                          {
                            icon: "fa-prescription-bottle",
                            title: "Pharmaceuticals",
                            desc: "Pharmaceutical manufacturing and packaging systems.",
                          },
                          {
                            icon: "fa-pepper-hot",
                            title: "Spices",
                            desc: "Automated spice grinding and packaging systems.",
                          },
                          {
                            icon: "fa-atom",
                            title: "Chemical",
                            desc: "Chemical processing and manufacturing solutions.",
                          },
                        ].map((service, index) => (
                          <li
                            key={index}
                            className="flex items-center"
                            style={{ height: "75px" }}
                          >
                            <i
                              className={`fas ${service.icon} text-lg p-2 mr-4`}
                              style={{
                                border: "1px solid #2d86a4",
                                borderRadius: "10%",
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            ></i>
                            <div className="flex-1">
                              <a
                                href="/service"
                                className="font-semibold text-black"
                              >
                                {service.title}
                              </a>
                              <a href="/service">
                                <p className="text-xs text-para">
                                  {service.desc}
                                </p>
                              </a>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div> */}
                <a
                  href="/contact"
                  className="flex items-center xl:text-base pt-1 text-sm text-black"
                >
                  Contact
                </a>

                <div className="flex gap-4">
                  <img
                    src={indiamap}
                    alt="India"
                    className={`cursor-pointer w-11 h-11 mt-1  ${selectedNavbar === "IN"
                      ? "border-b-4 border-blue-600"
                      : ""
                      }`}
                    onClick={() => setSelectedNavbar("IN")}
                  />
                  <img
                    src={uaemap}
                    alt="UAE"
                    className={`cursor-pointer w-12 h-12  text-black ${selectedNavbar === "UAE" ? "" : ""
                      }`}
                    onClick={() => setSelectedNavbar("UAE")}
                  />
                </div>
                <a href="/contact">
                  <button className="blue text-white xl:px-8 xl:py-2 lg:px-4 lg:py-2 rounded-md xl:mt-0 lg:mt-1">
                    Get A Quote
                  </button>
                </a>
              </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="xl:hidden lg:hidden md:block sm:block block">
        <div>
          <AdminNavbar />
        </div>
      </div>
    </section>
  );
};

export default IndexNavbarr;
